import React from 'react';
import './../../styles/irctcForgotPasswordPage.css';
import { navigateTo } from '../../utils/commonUtils';
import { getContinueBookingUrl } from '../../utils/RailsSEOConstants';

export const FirstBookingPersuation = () => {
  return (
    <div className="irctcLogin__bookNow">
      <span className="appendRight30">
        Book train tickets at MakeMyTrip and <span className="latoBold">get ₹50 off</span> at first booking.
      </span>
      <a onClick={() => navigateTo(getContinueBookingUrl())}>Book Now</a>
    </div>
  );
};

export default FirstBookingPersuation;
